import { DependentRelationship } from "./enums/dependent-relationship";
import { PlanType } from "./enums/plan-type";
import {isBefore, sub,format } from "date-fns";
import { formatDate } from "./formatters";


export const createGuid = () => {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}

export const getExistingContact = (contacts, lastName, firstName, birthdate) => {
    if(!contacts || !lastName || !firstName || !birthdate)
        return null;
    
    var contact = contacts.find(s => s.lastName === lastName && s.firstName === firstName &&  formatDate(s.birthdate) === formatDate(birthdate.toISOString()));
    if(contact)
        return {...contact};

    return null;
}

export const buildDependents = (enrollments) => {
    let results = [];
    if(Array.isArray(enrollments))
        return results;
    
    if(enrollments.dependents && enrollments.contacts){
        enrollments.dependents.forEach(id => {
            const contact = enrollments.contacts.find(s => s.id === id);
            if(contact)
                results.push({...contact});
        });
    }

    return results;
}

export const getQualifiedDependents = (enrollments) => {
    var qualifiedDependents = [];
    var contacts = getActiveContacts(enrollments);
    contacts.forEach(s =>  { 
        var isSpouse = DependentRelationship.SignificantOther.includes(s.relationship.id);
        if(isSpouse === true){
            var dependents = buildDependents(enrollments);
            if(!dependents.some(d => d.id === s.id) && !isMarried(enrollments)){
            } else
                qualifiedDependents.push(s);
        };

        var isChild = DependentRelationship.Children.includes(s.relationship.id);

        if(isChild === true){
            if(!isBefore(new Date(s.birthdate),getMaxChildAge() || s.hasDisability === true)){
                qualifiedDependents.push(s);
            }
        }
    });
    return qualifiedDependents;
}

export const isQualifiedDependent = (contact) => {
    var isSpouse = DependentRelationship.SignificantOther.includes(contact.relationship.id);
    if(isSpouse === true){
        return true;
    };
    var isChild = DependentRelationship.Children.includes(contact.relationship.id);

    if(isChild === true){
        if(!isBefore(new Date(contact.birthdate),getMaxChildAge() || contact.hasDisability === true)){
            return true;
        }
    }
return false;
}
export const isMarried = (enrollments) => {
    const isMarried = enrollments?.employee?.maritalStatus?.id === "M";
    return isMarried;
}
export const hasQualifiedDependents = (enrollments, beneficiaries) => {
    var contacts = getActiveContacts(enrollments, beneficiaries);
    var hasDependents = false;
     contacts.forEach(s =>  { 
        var isSpouse = DependentRelationship.SignificantOther.includes(s.relationship.id);
        if(isSpouse === true){
            var dependents = buildDependents(enrollments);
            if(!dependents.some(d => d.id === s.id) && !isMarried(enrollments)){
            } else{
            hasDependents = true;
            return}
        };
        var isChild = DependentRelationship.Children.includes(s.relationship.id);

        if(isChild === true){
            if(!isBefore(new Date(s.birthdate),getMaxChildAge() || s.hasDisability === true)){
                hasDependents = true;
                return;
            }
        }
    });
    return hasDependents;
}

const getMaxChildAge = () => {
    const yearsAgo = sub(new Date(),{years:26})
    const yearsAgoNum = format(yearsAgo, 'yyyy')
   
    return new Date(yearsAgoNum, 0 , 1);
}

const getActiveContacts = (enrollments, beneficiaries) => {
    var dependents = buildDependents(enrollments);
    if(!beneficiaries)
        beneficiaries = buildBeneficiaries(enrollments, true);
    
    beneficiaries = beneficiaries.filter(s => !dependents.some(d => d.id === s.id));
    const activeContacts = dependents.concat(beneficiaries);
    return activeContacts;
}




export const buildBeneficiaries = (enrollments, asContacts) => {
    let results = [];
    if(Array.isArray(enrollments))
        return results;

    var beneficiaryPlan = enrollments.selections?.find(s => s.planType === PlanType.BeneficiaryLife);
    if(beneficiaryPlan && beneficiaryPlan.beneficiaries && enrollments.contacts){
        beneficiaryPlan.beneficiaries.forEach(beneficiary => {
            const contact = enrollments.contacts.find(s => s.id === beneficiary.id);
            if(contact){
                let b = {...contact};
                if(!asContacts){
                    b.percentage = beneficiary.percentage;
                    b.type = beneficiary.type;
                }
                results.push(b);
            }
        });
    }

    results.sort((a, b) => {
        return new Date(a.birthdate) - new Date(b.birthdate);
    });


    return results;
}